import { render, staticRenderFns } from "./user_compo.vue?vue&type=template&id=3756c8b6&scoped=true&"
import script from "./user_compo.vue?vue&type=script&lang=js&"
export * from "./user_compo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756c8b6",
  null
  
)

export default component.exports